import {
  RELEVANT_INFLUENCER_LOAD_SUCCESS,
  RELEVANT_INFLUENCER_LOAD_FAILURE
} from '../constants';

const initState = [];

const relevantInfluencersReducer = (state = initState, action) => {
  switch (action.type) {
    case RELEVANT_INFLUENCER_LOAD_SUCCESS:
      return [...action.payload.influencers];
    default:
      return state;
  }
};

export default relevantInfluencersReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/relevantInfluencersReducer.js